<template>
    <div style="height: 100%">
        <b-tabs id="tabsRsaGestionePresenzeList" ref="tabsRsaGestionePresenze" v-model="activeTabIndex" nav-wrapper-class="sa-tab-items" content-class="mt-3" class="sa-tab" style="height: 100%; padding-bottom: 25px" fill @input="onInputTabs">
            <b-tab id="tbRsaGestionePresenti" title="Presenti" active>
                <rsa-gestione-ospiti-list-component ref="cmpRsaGestioneOspitiPresentiList"></rsa-gestione-ospiti-list-component>
            </b-tab>
            <b-tab id="tbRsaGestioneProgrammati" title="Programmati">
                <b-row>
                    <b-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                        <b-card class="sa-card sa-page-dashboard-card-body-chart" style="height: 100%" header="Ospiti in uscita" header-tag="header" footer-tag="footer" title="">
                            <rsa-gestione-presenze-programmati-component ref="cmpRsaGestionePresenzeProgrammatiUsciteProgrammate" :isUscitaProgrammata="true" @afterSaveData="onAfterSaveDataUsciteProgrammate"></rsa-gestione-presenze-programmati-component>
                        </b-card>
                    </b-col>
                    <b-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                        <b-card class="sa-card sa-page-dashboard-card-body-chart" style="height: 100%" header="Ospiti in entrata" header-tag="header" footer-tag="footer" title="">
                            <rsa-gestione-presenze-programmati-component ref="cmpRsaGestionePresenzeProgrammatiEntrate" :isUscitaProgrammata="false" @afterSaveData="onAfterSaveDataUsciteProgrammate"></rsa-gestione-presenze-programmati-component>
                        </b-card>
                    </b-col>
                </b-row>
            </b-tab>
            <b-tab id="tbRsaGestioneAssenti" title="Assenti">
                <rsa-gestione-ospiti-list-component ref="cmpRsaGestioneOspitiAssentiList"></rsa-gestione-ospiti-list-component>
            </b-tab>
        </b-tabs>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaGestioneOspitiListComponent from "../../rsagestioneospiti/components/RsaGestioneOspitiListComponent.vue";
import RsaGestionePresenzeProgrammatiComponent from "./RsaGestionePresenzeProgrammatiComponent.vue";

export default {
    props: {},
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    components: { RsaGestionePresenzeProgrammatiComponent, RsaGestioneOspitiListComponent },
    mixins: [UtilityMixin],
    data() {
        return { pathresource: "", jsonData: {}, activeTabIndex: 0, filtroGestionePresenze: {} };
    },
    computed: {},
    mounted() {},
    watch: {},
    methods: {
        init() {
            let me = this;
            me.onInputTabs(me.activeTabIndex);
        },
        onInputTabs(index) {
            let me = this;
            me.openShowModalLoading();
            let activeTab = this.$refs.tabsRsaGestionePresenze.getTabs()[index];
            me.activeTab(activeTab.id);
        },
        activeTab(idActiveTab) {
            let me = this;
            let sessionStorage = window.sessionStorage;
            if (sessionStorage["filtroGestionePresenze"]) {
                me.filtroGestionePresenze = JSON.parse(sessionStorage["filtroGestionePresenze"]);
            }
            switch (idActiveTab) {
                case "tbRsaGestionePresenti":
                    me.filtroGestionePresenze.stato = "RICOVERATO";
                    delete me.filtroGestionePresenze.dataDal;
                    delete me.filtroGestionePresenze.dataAl;
                    me.$refs.cmpRsaGestioneOspitiPresentiList.init(me.filtroGestionePresenze, false);
                    break;
                case "tbRsaGestioneProgrammati":
                    me.$refs.cmpRsaGestionePresenzeProgrammatiUsciteProgrammate.init("USCITA PROGRAMMATA", true);
                    me.$refs.cmpRsaGestionePresenzeProgrammatiEntrate.init("USCITA", false);
                    break;
                case "tbRsaGestioneAssenti":
                    me.filtroGestionePresenze.stato = "ASSENTE";
                    delete me.filtroGestionePresenze.dataDal;
                    delete me.filtroGestionePresenze.dataAl;
                    me.$refs.cmpRsaGestioneOspitiAssentiList.init(me.filtroGestionePresenze, false);
                    break;
            }
            me.closeShowModalLoading();
        },
        onAfterSaveDataUsciteProgrammate() {
            this.onInputTabs(1);
        },
    },
};
</script>
<style></style>
